"use client";
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { forwardRef as D, createElement as P } from "react";
import o from "../../../elements/EventDateAndVenue/EventDateAndVenue.js";
import c from "../../../layout/Container/Container.js";
import { resolveSize as d, PADDING_SIZES as m } from "../../../layout/Container/Container.helpers.js";
import { rem as g, Box as k, Overlay as B, Image as H, Group as s, Grid as l, Heading as S, Link as j, Icon as A, Paragraph as G, Button as x, Carousel as I } from "@ingeniorforeningen/figurine-core";
import '../../../../assets/HeroEvent.css';const F = "_container_1y9vv_2", L = "_image_1y9vv_15", R = "_overlay_1y9vv_22", V = "_content_1y9vv_26", O = "_title_1y9vv_40", Z = "_contentBottom_1y9vv_56", q = "_btnProgram_1y9vv_60", J = "_textsContainer_1y9vv_69", K = "_texts_1y9vv_69", M = "_description_1y9vv_89", Q = "_carousel_1y9vv_103", t = {
  container: F,
  image: L,
  overlay: R,
  content: V,
  title: O,
  contentBottom: Z,
  btnProgram: q,
  textsContainer: J,
  texts: K,
  description: M,
  carousel: Q
}, _ = D((h, u) => {
  const { image: y, heading: f, description: b, editLink: v, ...N } = h, {
    leftCta: n,
    rightCta: r,
    occurences: i,
    active: C = !0,
    inactiveDescription: p,
    ...w
  } = N, E = {
    "--passed-margin-xs": `calc(((100% - ${d("global").xs}px) / 2))`,
    "--passed-margin-lg": `calc(((100% - ${d("global").lg}px) / 2))`,
    "--passed-margin-xl": `calc(((100% - ${d("global").xl}px) / 2))`,
    "--passed-padding-xl": g(`${m.xl}px`),
    "--passed-padding-lg": g(`${m.lg}px`),
    "--passed-padding-xs": g(`${m.base}px`)
  };
  return /* @__PURE__ */ a(k, { ref: u, ...w, className: t.container, style: E, children: [
    /* @__PURE__ */ e(
      B,
      {
        gradient: "linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%)",
        opacity: 0.85,
        className: t.overlay
      }
    ),
    /* @__PURE__ */ e(
      H,
      {
        ...y,
        caption: void 0,
        byline: void 0,
        orientation: "landscape",
        fit: "cover",
        width: "edge",
        className: t.image,
        children: /* @__PURE__ */ a(
          s,
          {
            className: t.content,
            direction: "column",
            justify: "center",
            wrap: "nowrap",
            spacing: 0,
            children: [
              /* @__PURE__ */ e(c, { size: "global", className: t.textsContainer, children: /* @__PURE__ */ a(l, { container: !0, children: [
                /* @__PURE__ */ a(l, { item: !0, xs: 12, sm: 6, className: t.texts, spacing: 0, children: [
                  /* @__PURE__ */ e(
                    S,
                    {
                      text: f,
                      type: "display",
                      variant: "light",
                      align: "left",
                      className: t.title
                    }
                  ),
                  v && /* @__PURE__ */ e(j, { href: v, target: "_blank", children: /* @__PURE__ */ e(A, { name: "Edit", size: "xl", color: "light" }) }),
                  /* @__PURE__ */ e(
                    G,
                    {
                      visibleFrom: "24.375em",
                      text: b,
                      variant: "light",
                      className: t.description,
                      mt: "sm",
                      mb: "sm",
                      align: "left",
                      balanced: !0
                    }
                  )
                ] }),
                /* @__PURE__ */ e(
                  l,
                  {
                    item: !0,
                    xs: 12,
                    sm: 8,
                    className: t.buttonsContainer,
                    visibleFrom: "xs",
                    children: /* @__PURE__ */ a(s, { spacing: "xl", justify: "left", children: [
                      n && /* @__PURE__ */ e(
                        x,
                        {
                          text: n.text,
                          href: n.href,
                          target: n.target,
                          variant: "cta",
                          className: t.btnCta,
                          icon: "ArrowRight"
                        }
                      ),
                      r && /* @__PURE__ */ e(
                        x,
                        {
                          text: r.text,
                          href: r.href,
                          target: r.target,
                          variant: "outline",
                          className: t.btnProgram
                        }
                      )
                    ] })
                  }
                )
              ] }) }),
              C ? i?.length > 0 ? i.length === 1 ? /* @__PURE__ */ e(c, { size: "global", mb: "xl", children: /* @__PURE__ */ e(s, { className: t.singleCardContainer, children: /* @__PURE__ */ e(o, { ...i[0], active: !0 }) }) }) : /* @__PURE__ */ e(l, { container: !0, className: t.carousel, children: /* @__PURE__ */ e(I, { draggable: !0, slideSize: "21.4375em", withControls: !1, slideGap: "xl", children: i.map(($, z) => /* @__PURE__ */ P(
                o,
                {
                  ...$,
                  active: !0,
                  key: `event-date-and-venue-${z}`
                }
              )) }) }) : null : p && /* @__PURE__ */ e(c, { size: "global", mb: "xl", children: /* @__PURE__ */ e(s, { className: t.singleCardContainer, children: /* @__PURE__ */ e(
                o,
                {
                  variant: "transparent",
                  active: !1,
                  inactiveDescription: p,
                  date: /* @__PURE__ */ new Date(),
                  duration: "",
                  venueName: "",
                  venueAddress: "",
                  deadline: /* @__PURE__ */ new Date(),
                  link: {
                    href: ""
                  }
                }
              ) }) })
            ]
          }
        )
      }
    )
  ] });
});
_.displayName = "HeroEvent";
const te = _;
export {
  _ as _HeroEvent,
  te as default
};
